<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-title>
          {{ editMode ? $t('replaceUser') : $t('createUser') }}
        </v-card-title>
        <v-list-item>
          <v-list-item-content>
            <v-form ref="form" v-model="valid">
              <v-text-field
                id="f679b3c9"
                v-model="username"
                :label="$t('username')+`*`"
                :disabled="editMode"
                :counter="maxCharacters"
                :rules="[rules.required, rules.minMax]"
              ></v-text-field>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-if="!editMode"
                    id="7878ba35"
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('password')+`*`"
                    :counter="maxCharacters"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.minMax]"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="!editMode"
                    id="c467aa9b"
                    v-model="rePassword"
                    :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :label="$t('passwordConfirmation')+`*`"
                    :counter="maxCharacters"
                    :type="showRePassword ? 'text' : 'password'"
                    :rules="[rules.required, rules.minMax, rules.passwordMatch]"
                    validate-on-blur
                    @click:append="showRePassword = !showRePassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col id="499eb98a" cols="6" md="4">
                  <v-select
                    v-model="roles"
                    :items="roleList"
                    :label="$t('select') +' ' + $t('roles')+`*`"
                    :rules="[rules.atLeastOneItem]"
                    multiple
                    chips
                    validate-on-blur
                  ></v-select>
                </v-col>
              </v-row>
              <small>*{{ $t('indicatesRequiredField') }}</small>
            </v-form>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-btn
            id="f684e580"
            class="ma-2"
            color="primary"
            :disabled="!valid"
            @click="createOrUpdateUser"
          >
            {{ editMode ? $t('replace') : $t('create') }}
          </v-btn>
          <v-btn
            id="8df7cce0"
            class="ma-2"
            @click="back"
          >
            {{ $t('back') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import users from '@/api/users'
import Role from '../../Role'
import { showToastSuccess, showToastError } from '../../event-bus'

export default {
  name: 'CreateAndEditUser',

  data() {
    return {
      valid: true,
      maxCharacters: 255,
      username: null,
      password: null,
      rePassword: null,
      roleList: [Role.SO, Role.ADMIN, Role.OPERATOR, Role.AUDITOR],
      roles: [],
      showPassword: false,
      showRePassword: false,
      rules: {
        required: v => !!v || this.$t('validation.requiredField'),
        minMax: v => (v && v.length <= this.maxCharacters) || this.$t('validation.mustBeLessThan', { max: this.maxCharacters }),
        passwordMatch: v => (v === this.password) || this.$t('validation.passwordMustBeIdentical'),
        atLeastOneItem: v => (v && v.length > 0) || this.$t('validation.atLeastOneItem')
      }
    }
  },

  computed: {
    editMode() {
      return this.$route.params.userId != null
    }
  },

  mounted() {
    if (this.editMode) {
      this.getUser()
    }
  },

  methods: {
    async getUser() {
      if (this.editMode) {
        try {
          let user = await users.getUser(this.$route.params.userId)
          this.username = user.username
          this.roles = user.roles
        } catch (error) {
          showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
        }
      } else {
        this.username = ''
        this.roles = []
      }
    },

    async createOrUpdateUser() {
      if (!this.$refs.form.validate()) {
        return
      }

      let userDto = {
        username: this.username,
        password: this.password,
        roles: this.roles
      }
      try {
        this.editMode ? await users.updateUser(this.$route.params.userId, userDto) : await users.createUser(userDto)
        showToastSuccess(this.editMode ? this.$t('toastMessage.succesfullyUpdated') : this.$t('toastMessage.succesfullyCreated'))
        this.back()
      } catch (error) {
        let errorMsg = this.$t('toastMessage.errorWhileRetrievingData')
        if (error.response != null) {
          switch (error.response.data.code) {
            case 'ALREADY_EXISTS':
              errorMsg = this.$t('toastMessage.alreadyExist')
          }
        }
        showToastError(errorMsg)
      }
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>
